import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'safeUrl',
    standalone: true
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private dom: DomSanitizer) {}
  transform(value) {
    return this.dom.bypassSecurityTrustUrl(value);
  }
}
